// extracted by mini-css-extract-plugin
export default {"list":"Wc52ZYm2PAozuTb2eTkQ","item":"jdusXFC5_SW2B3Ke5dad"};